function showHideLogo(el) {
  const rect = el.getBoundingClientRect();
  const logo = el.querySelector("[data-sticky-nav-logo]");
  if (rect.top === 0) {
    logo.classList.remove("opacity-0");
  } else {
    logo.classList.add("opacity-0");
  }
}

function updateCurrentNav(el) {
  const navItems = document.querySelectorAll("[data-sticky-nav-item]");
  const currentIndexes = [0];

  navItems.forEach((item, i) => {
    const anchorEl = document.getElementById(item.dataset.stickyNavItem);
    const rect = anchorEl.getBoundingClientRect();
    item.classList.add("border-transparent");
    item.classList.remove("border-rich-green");
    if ((rect.top - el.clientHeight) < 0) {
      currentIndexes.push(i);
    }
  });

  const currentIndex = currentIndexes[currentIndexes.length - 1];

  navItems[currentIndex].classList.remove("border-transparent");
  navItems[currentIndex].classList.add("border-rich-green");
}

function StickyNav(el) {
  document.addEventListener("scroll", function() {
    showHideLogo(el);
    updateCurrentNav(el);
  });

  document.addEventListener("resize", function() {
    showHideLogo(el);
    updateCurrentNav(el);
  });
}

export function bindStickyNav() {
  return [...document.querySelectorAll("[data-sticky-nav]")].map((el) => StickyNav(el));
}
